import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { ThemeProvider } from '@pets-ui/ThemeProvider/ThemeProvider'
import { colorTheme as fastpassColorTheme } from '@pets-ui/themes/fastpass'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { Asterisk } from '../../../../../components/Asterisk/Asterisk'
import { PaymentMethodComponent } from './PaymentMethodComponent'

const styles = stylex.create({
  root: {
    padding: 20,
  },
})

export function PaymentMethod() {
  return (
    <>
      <VStack gap={2}>
        <ThemeProvider theme={fastpassColorTheme}>
          <Paper elevation={0} borderRadius={8} rootStyle={styles.root}>
            <VStack gap={2} alignItems="flex-start" width="100%">
              <Text variant="subtitle" color={colors.grey900}>
                付款方式
                <Asterisk />
              </Text>
              <PaymentMethodComponent />
            </VStack>
          </Paper>
        </ThemeProvider>
      </VStack>
    </>
  )
}
